import React, {Fragment} from 'react';
import clsx from 'clsx';
import { PropTypes } from 'prop-types';
import IconContainer from '../IconContainer';
import SpecialLink from './SpecialLink';
import * as blocLiensStyles from '../../../styles/admissions/admissions.module.scss';

const ActionElementList = ({title, actions, color}) => {
  return (
    <>
      <div
        className={clsx(blocLiensStyles.containerTitleActionElement, {
          [blocLiensStyles.darkBlocLiensEntete]: color === 'BLACK',
          [blocLiensStyles.redBlocLiensEntete]: color !== 'BLACK'
        })}
      >
        <div className={blocLiensStyles.titleActionElement}>
          <h2 className={blocLiensStyles.relatedTitleActionList}>{title}</h2>
        </div>
      </div>
      <div
        className={clsx(blocLiensStyles.rootActionListCorps, {
          [blocLiensStyles.darkActionListCorps]: color === 'BLACK',
          [blocLiensStyles.redActionListCorps]: color !== 'BLACK'
        })}
      >
        {actions?.map((action, index, arr) => {
          return (
            <Fragment key={index}>
              <div
                className={clsx(blocLiensStyles.actionMan,
                  {[blocLiensStyles.margin]: index < arr.length - 1}
                )}
              >
                <SpecialLink
                  icon={action.icon === 'DOWNLOAD' ?
                    <IconContainer
                      color="RED"
                      icon={'DOWNLOAD'}
                      noHover
                      size={25}
                      style={{padding: '5px'}}
                      svgClassname={clsx(blocLiensStyles.downloadSvgIcon, blocLiensStyles.actionSvgIcon)}
                      tabIndex={-1}
                      variant="outlined"
                    />
                    :
                    <IconContainer
                      color="RED"
                      icon={action.icon}
                      noHover
                      size={25}
                      style={{padding: '5px'}}
                      svgClassname={blocLiensStyles.actionSvgIcon}
                      tabIndex={-1}
                      variant="outlined"
                    />}
                  isRelatedContent
                  link={action.URL}
                  noIcon
                  title={action.label}
                  window={action.new_window}
                />
              </div>
              {index < arr.length - 1
          && (
            <div
              className={clsx(blocLiensStyles.separation, blocLiensStyles.margin)}
            />
          )}
            </Fragment>
          );
        })}
      </div>
    </>
  );
};

ActionElementList.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    URL: PropTypes.string,
    icon: PropTypes.string.isRequired,
    new_window: PropTypes.bool,
  })),
  color: PropTypes.oneOf(['BLACK', 'RED']),
  title: PropTypes.string.isRequired,
};

export default ActionElementList;
